var Marionette = require('backbone.marionette');

var CommonUtils = require('../../utils/common-utils.js');


var MergeFromPersonDemographicsView = Marionette.View.extend({
    template: require('../../templates/persons/merge-from-person-demographics-view.html'),
    modelEvents: {
        change: 'render'
    },

    ui: {
        merge: '.merge'
    },

    events: {
        'click @ui.merge': 'onMerge'
    },

    templateContext: function () {
        var that = this;
        var bd = that.model.get('object').birthData;
        return {
            birthData: (bd == '' || bd == null || bd == 0 ? '' : that.utils.longToDateTimeFormatted(Number(bd), 'MM/DD/YYYY')),
            mergeFromPersonId: that.getOption('mergeFromPersonId'),
            mergeFromPersonName: that.getOption('mergeFromPersonName'),
            isHidden: function(field) {
                return that.getOption('isBeingMerged')(field) ? 'hidden' : ''
            },
            isDeprecated: function(field) {
                return that.getOption('isBeingMerged')(field) ? 'deprecated-header' : ''
            }
        }
    },

    initialize: function (options) {
        this.model.on('change', this.render, this);
        this.model = options.model;
        this.utils = new CommonUtils();
    },

    onRender: function () {
    },

    onMerge: function(event) {
        this.triggerMethod('merge:person:demographics', event.target.id.replace('span.', ''));
    }
});

module.exports = MergeFromPersonDemographicsView;


//////////////////
// WEBPACK FOOTER
// ./app/views/persons/merge-from-person-demographics-view.js
// module id = 478
// module chunks = 0